export default __webpack_public_path__ + "resources/icons/d132-2386.png";